"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesModule = void 0;
const tslib_1 = require("tslib");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
/**
 * In the first iteration a cell can have only one note, the
 * notes is a list to allow further development.
 */
class NotesModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.NotesModuleId, ModuleConstants.NotesFriendlyName, 'note', 'NotesPopup', 'Notes', api);
        this.adaptable = api.internalApi.getAdaptableInstance();
        this.adaptable.api.eventApi.on('AdaptableReady', () => this.handleAdaptableReady());
    }
    isModuleAvailable() {
        // FIXME remove this once Notes feature is public
        return false;
    }
    handleAdaptableReady() {
        if (!this.isModuleAvailable()) {
            return;
        }
        this.adaptable._on('MouseEnter', (event) => this.handleMouseEnter(event));
        this.api.eventApi.on('CellSelectionChanged', (params) => {
            const cells = params.selectedCellInfo.gridCells;
            if ((cells === null || cells === void 0 ? void 0 : cells.length) === 1) {
                const selectedCell = cells[0];
                const cellSelected = {
                    PrimaryKeyValue: selectedCell.primaryKeyValue,
                    ColumnId: selectedCell.column.columnId,
                };
                this.handleCellSelected(cellSelected);
            }
        });
    }
    addContextMenuItems(menuContext) {
        var _a, _b;
        if (!this.isModuleAvailable()) {
            return undefined;
        }
        const items = [];
        const isCellNotable = (_b = (_a = this.adaptable.api.optionsApi) === null || _a === void 0 ? void 0 : _a.getNotesOptions()) === null || _b === void 0 ? void 0 : _b.isCellNotable;
        if (!isCellNotable ||
            isCellNotable({
                adaptableApi: this.adaptable.api,
                primaryKeyValue: menuContext.primaryKeyValue,
                columnId: menuContext.adaptableColumn.columnId,
                userName: this.adaptable.api.optionsApi.getUserName(),
                adaptableId: this.adaptable.adaptableOptions.adaptableId,
            }))
            items.push(...this.getAddRemoveNoteMenuItems(menuContext));
        return items;
    }
    getAddRemoveNoteMenuItems(menuContext) {
        var _a;
        const items = [];
        // does not have note
        const [note] = (_a = this.adaptable.api.notesApi.getCellNotes({
            PrimaryKeyValue: menuContext.primaryKeyValue,
            ColumnId: menuContext.adaptableColumn.columnId,
        })) !== null && _a !== void 0 ? _a : [];
        if (note) {
            items.push(this.createColumnMenuItemClickFunction('Remove Note', this.moduleInfo.Glyph, () => {
                this.api.notesApi.deleteNote(note);
            }));
        }
        else {
            items.push(this.createColumnMenuItemClickFunction('Add Note', this.moduleInfo.Glyph, () => {
                // add an empty one
                this.api.notesApi.addNote('', menuContext.primaryKeyValue, menuContext.adaptableColumn.columnId);
                this.api.notesApi.showNotes({
                    PrimaryKeyValue: menuContext.primaryKeyValue,
                    ColumnId: menuContext.adaptableColumn.columnId,
                }, true);
            }));
        }
        return items;
    }
    getCellPositionFromEvent(event) {
        var _a, _b;
        const target = event.target;
        if (!((_b = (_a = target === null || target === void 0 ? void 0 : target.classList) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, 'ag-cell'))) {
            return null;
        }
        try {
            return {
                PrimaryKeyValue: target.parentElement.getAttribute('row-id'),
                ColumnId: target.getAttribute('col-id'),
            };
        }
        catch (e) {
            return null;
        }
    }
    handleMouseEnter(event) {
        var _a;
        const editMode = this.adaptable.api.notesApi.getNotePopupEditMode();
        if (editMode) {
            // ignore
            return;
        }
        const cellPosition = this.getCellPositionFromEvent(event);
        const openNoteGridCell = this.adaptable.api.notesApi.getOpenNoteGridCell();
        // Hovering over someting that is not a cell and there is no open note
        if (!cellPosition && openNoteGridCell) {
            // need to close if the new cell does not have a note
            this.adaptable.api.notesApi.hideNote();
        }
        else if ((_a = this.adaptable.api.notesApi.getCellNotes(cellPosition)) === null || _a === void 0 ? void 0 : _a.length) {
            this.adaptable.api.notesApi.showNotes(cellPosition, false);
        }
    }
    handleCellSelected(noteGridCell) {
        // if already opened - do nothing
        const openNoteGridCell = this.adaptable.api.notesApi.getOpenNoteGridCell();
        if ((openNoteGridCell === null || openNoteGridCell === void 0 ? void 0 : openNoteGridCell.PrimaryKeyValue) === noteGridCell.PrimaryKeyValue &&
            (openNoteGridCell === null || openNoteGridCell === void 0 ? void 0 : openNoteGridCell.ColumnId) === noteGridCell.ColumnId) {
            return;
        }
        // if open but this has no note, close
        const cellNotes = this.adaptable.api.notesApi.getCellNotes(noteGridCell);
        if (openNoteGridCell && !(cellNotes === null || cellNotes === void 0 ? void 0 : cellNotes.length)) {
            // hide only if in edit mode
            // because if you select a cell and move the mouse fast over another cell
            // with a note, you do not want to close that note
            // the selection is debounced, so the moment goes over the new cell this event is triggered
            if (this.adaptable.api.notesApi.getNotePopupEditMode()) {
                this.adaptable.api.notesApi.hideNote();
            }
            return;
        }
        // if open but the new selection has a note open that one in edit mode (because of click)
        if (openNoteGridCell && (cellNotes === null || cellNotes === void 0 ? void 0 : cellNotes.length)) {
            this.adaptable.api.notesApi.showNotes(noteGridCell, true);
            return;
        }
    }
}
exports.NotesModule = NotesModule;
